import { render, staticRenderFns } from "./SettlementHistoriesDetail.vue?vue&type=template&id=07210dbd"
import script from "./SettlementHistoriesDetail.vue?vue&type=script&lang=js"
export * from "./SettlementHistoriesDetail.vue?vue&type=script&lang=js"
import style0 from "./SettlementHistoriesDetail.vue?vue&type=style&index=0&id=07210dbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports